(function () {
  'use strict';

  function cloneMarqueeChildren(track, itemSelector) {
    if (!track || track.dataset.marqueeCloned === '1') return;
    var items = track.querySelectorAll(itemSelector);
    if (!items.length) return;
    items.forEach(function (node) {
      var clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      if (clone.tagName === 'A') clone.setAttribute('tabindex', '-1');
      track.appendChild(clone);
    });
    track.dataset.marqueeCloned = '1';
  }

  function initSbMarquee() {
    var wrap = document.getElementById('sb-marquee-wrap');
    var track = document.getElementById('sb-marquee-track') || (wrap && wrap.querySelector('.sb-marquee'));
    if (!wrap || !track) return;

    function isVisible() {
      return wrap.style.display === 'flex' || (wrap.offsetParent !== null && getComputedStyle(wrap).display !== 'none');
    }

    function buildLoop() {
      if (!isVisible()) return false;
      if (track.dataset.marqueeReady === '1') return true;

      var itemSel = '.sb-marquee-item, .sb-marquee-sep';
      track.querySelectorAll('[data-marquee-clone]').forEach(function (n) {
        n.parentNode.removeChild(n);
      });

      var originals = Array.from(track.querySelectorAll(itemSel));
      if (!originals.length) return false;

      var guard = 0;
      while (track.scrollWidth < wrap.clientWidth && guard < 12) {
        originals.forEach(function (node) {
          var c = node.cloneNode(true);
          c.setAttribute('data-marquee-clone', 'extend');
          c.setAttribute('aria-hidden', 'true');
          track.appendChild(c);
        });
        guard += 1;
      }

      var half = Array.from(track.children);
      half.forEach(function (node) {
        var c = node.cloneNode(true);
        c.setAttribute('data-marquee-clone', 'mirror');
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      });

      var loopW = track.scrollWidth / 2;
      var pxPerSec = 110;
      var dur = Math.max(14, Math.min(40, loopW / pxPerSec));
      track.style.animationDuration = dur + 's';
      track.dataset.marqueeReady = '1';
      return true;
    }

    if (!buildLoop()) {
      var tries = 0;
      var poll = setInterval(function () {
        tries += 1;
        if (buildLoop() || tries > 120) clearInterval(poll);
      }, 500);
    }

    if (window.MutationObserver && !wrap.dataset.marqueeObs) {
      wrap.dataset.marqueeObs = '1';
      var obs = new MutationObserver(function () {
        if (isVisible() && track.dataset.marqueeReady !== '1') buildLoop();
      });
      obs.observe(wrap, { attributes: true, attributeFilter: ['style', 'class'] });
    }
  }

  window.curseInitSbMarquee = initSbMarquee;

  function initJourneyTicker() {
    var track = document.querySelector('.chs-journey-ticker__track');
    if (!track) return;
    var spans = track.querySelectorAll('span:not(.chs-journey-ticker__dot)');
    if (spans.length < 2) return;
    var mid = Math.floor(spans.length / 2);
    if (mid > 0 && spans[mid].textContent === spans[0].textContent) {
      while (track.children.length > mid * 2 - 1) {
        track.removeChild(track.lastElementChild);
      }
    }
    cloneMarqueeChildren(track, 'span');
  }

  function initYotpoMarqueeRow() {
    document.querySelectorAll('[data-chs-marquee-track] .chs-marquee__row').forEach(function (row) {
      if (row.nextElementSibling && row.nextElementSibling.classList.contains('chs-marquee__row')) {
        row.nextElementSibling.setAttribute('aria-hidden', 'true');
        row.nextElementSibling.querySelectorAll('a, button').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
      }
    });
  }

  function initConnectedCatRail() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.chs-cat-rail--connected').forEach(function (rail) {
      if (rail.dataset.marqueeCloned === '1') return;
      var cards = Array.from(rail.querySelectorAll('.chs-cat-card'));
      if (cards.length < 2) return;
      var half = Math.floor(cards.length / 2);
      if (half > 0 && cards[half].textContent.trim() === cards[0].textContent.trim()) {
        cards.slice(half).forEach(function (node) {
          node.parentNode.removeChild(node);
        });
        cards = Array.from(rail.querySelectorAll('.chs-cat-card'));
      }
      cards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        rail.appendChild(clone);
      });
      rail.dataset.marqueeCloned = '1';
    });
  }

  function boot() {
    initSbMarquee();
    initJourneyTicker();
    initYotpoMarqueeRow();
    initConnectedCatRail();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('curse:reviews-rendered', initYotpoMarqueeRow);
})();
